import React from 'react';
import { createPortal } from 'react-dom';
import TermsContent from './TermsContent';
import PrivacyContent from './PrivacyContent';

interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'terms' | 'privacy';
}

const LegalModal: React.FC<LegalModalProps> = ({ isOpen, onClose, type }) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100000] overflow-y-auto"
      onClick={onClose}
    >
      <div className="flex min-h-full items-center justify-center p-4 lg:p-12">
        <div
          className="bg-white rounded-lg w-full max-w-[95%] flex flex-col shadow-2xl overflow-hidden relative"
          style={{ maxHeight: 'calc(100vh - 4rem)' }}
          onClick={e => e.stopPropagation()}
        >
          {/* Header */}
          <div className="px-8 pt-8 pb-2">
            <h2 className="text-2xl font-extrabold text-gray-900">
              {type === 'terms' ? 'Terms of Use' : 'PRAIRI Privacy Policy'}
            </h2>
            <div className="w-full h-[1px] bg-gray-200 mt-5" />
            <p className="text-sm text-gray-600 italic mt-4">
              Last revision: {type === 'terms' ? '19 October 2024' : '17 November 2023'}
            </p>
          </div>

          {/* Content Area */}
          <div className="flex-1 overflow-y-auto px-8 py-6 custom-scrollbar-light min-h-0">
            {type === 'terms' ? <TermsContent /> : <PrivacyContent />}
          </div>

          {/* Footer */}
          <div className="px-8 py-5 border-t border-gray-100 flex justify-start bg-white">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-[#4285F4] hover:bg-[#357ae8] text-white font-bold rounded shadow-sm transition-all duration-200 transform active:scale-95"
              id="modal-close-button"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LegalModal;
